<template>
    <nav class="header" :class="isOpen ? 'opened' : 'closed'">
      <div class="container">
        <img class="logo" alt="Revive logo" src="@/assets/logo.svg">
        <div class="menu-items">
          <router-link class="menu-item" :class="{ active: $route.path === '/' }" @click="() => isOpen = false" to="/">
            <span class="menu-text">Home</span>
          </router-link>
          <router-link class="menu-item" :class="{ active: $route.path === '/news-list' }" @click="() => isOpen = false" to="/news-list">
            <span class="menu-text">News</span>
          </router-link>
          <router-link class="menu-item" :class="{ active: $route.path === '/projects-list' }" @click="() => isOpen = false" to="/projects-list">
            <span class="menu-text">Projects</span>
          </router-link>
          <router-link class="menu-item" :class="{ active: $route.path === '/about' }" @click="() => isOpen = false" to="/about">
            <span class="menu-text">About</span>
          </router-link>
          <router-link class="menu-item donate-link" :class="{ active: $route.path === '/donations' }" @click="() => isOpen = false" to="/donations">
            <span class="menu-text">Donate</span>
          </router-link>
        </div>
        <div class="menu-hamburger" @click="() => isOpen = !isOpen"> 
            <img alt="Menu" src="@/assets/menu.svg">
        </div>
      </div>
    </nav>
</template>
<script setup>
    import { ref } from 'vue';
    const isOpen = ref(false);
</script>
<style lang="scss">
    .header {
        background-color: var(--primary-background-color);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        z-index: 1000;
        position: sticky;
        top: 0;
        transition: all 0.3s ease;
        backdrop-filter: blur(10px);
        border-bottom: 1px solid rgba(0, 83, 1, 0.1);

        .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1rem 2rem;
            max-width: 1200px;
            margin: 0 auto;
        }
    }
  
    .menu-hamburger {
        display: none;
        transition: all 0.3s ease;
        
        &:hover {
            background-color: rgba(0, 83, 1, 0.1);
        }
    }

    .menu-items {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 2.5rem;
        
        .menu-item {
            text-decoration: none;
            color: var(--font-color);
            position: relative;
            padding: 0.5rem 0;
            transition: all 0.3s ease;
            font-weight: 500;
            
            .menu-text {
                position: relative;
                z-index: 2;
            }
            
            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 0;
                height: 2px;
                background-color: var(--primary-color);
                transition: width 0.3s ease;
            }
            
            &:hover {
                color: var(--primary-color);
                
                &::after {
                    width: 100%;
                }
            }
            
            &.active {
                color: var(--primary-color);
                
                &::after {
                    width: 100%;
                }
            }
            
            &.donate-link {
                background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
                color: white;
                padding: 0.75rem 1.5rem;
                border-radius: 25px;
                font-weight: 600;
                box-shadow: 0 4px 15px rgba(0, 83, 1, 0.3);
                transition: all 0.3s ease;
                
                &:hover {
                    box-shadow: 0 6px 20px rgba(0, 83, 1, 0.4);
                    color: white;
                }
                
                &::after {
                    display: none;
                }
            }
        }
    }

    @media only screen and (max-width: 1024px) { 
        .header {
            .container {
                padding: 1rem;
            }
        }
        
        .menu-hamburger {
            position: absolute;
            right: 1rem;
            top: 1.5rem;
            display: block;
            cursor: pointer;
            z-index: 1001;
            padding: 0.5rem;
            border-radius: 8px;
            transition: all 0.3s ease;
            
            &:hover {
                background-color: rgba(0, 83, 1, 0.1);
            }
        }

        .closed {
            .menu-items {
                display: none;
            }
        }

        .opened {
            .container {
                flex-direction: column;
                gap: 1rem;
                padding: 1rem;
                background: rgba(255, 255, 255, 0.95);
                backdrop-filter: blur(10px);
                border-radius: 0 0 16px 16px;
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

                .logo {
                    margin: auto;
                    order: -1;
                }

                .menu-items {
                    margin-bottom: 1rem;
                    flex-direction: column;
                    gap: 1.5rem;
                    width: 100%;
                    
                    .menu-item {
                        padding: 1rem;
                        border-radius: 8px;
                        text-align: center;
                        font-weight: 600;
                        transition: all 0.3s ease;
                        
                        &:hover {
                            background-color: rgba(0, 83, 1, 0.1);
                            transform: translateX(8px);
                        }
                        
                        &.donate-link {
                            margin: 0.5rem 0;
                        }
                    }
                }
            }
        }
    }
    
    @media only screen and (max-width: 768px) {
        .header {
            .container {
                padding: 0.75rem;
            }
        }
        
        .menu-hamburger {
            right: 0.75rem;
            top: 1.25rem;
        }
        
        .opened {
            .container {
                padding: 0.75rem;
                
                .menu-items {
                    gap: 1rem;
                    
                    .menu-item {
                        padding: 0.75rem;
                        font-size: 0.95rem;
                    }
                }
            }
        }
    }
</style>